import { DeviceSubtypeRow } from 'components/tables/data/device-subtypes/types';
import P3Regular from 'components/typography/P3Regular';

/**
 * Column for the device subtype id.
 */
export default function DeviceSubtypeIdColumn({ data: { deviceTypeId } }: { data: DeviceSubtypeRow }) {
  return <P3Regular color="gray.8">{deviceTypeId}</P3Regular>;
}
